module.exports = __webpack_public_path__ + "static/media/box-container-flipped.5190e420.png";